import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Acción para obtener los datos de agua salada de un nodo
export const coordenadas = createAsyncThunk(
    'coordenadas/getTodasLasCoordenadasNodo',
    async () => {
        try {
            const response = await axios.get("/api/sensor/getTodasLasCoordenadasNodo");
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);